import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import LotteryService from '@/service/LotteryService'

Vue.config.productionTip = false

// Vue.prototype.$http = service

router.beforeEach((to, from, next) => {
    // console.log(to.query.user_code)
    if (to.name === 'Index') {
        let userCode = to.query.user_code;
        let session = to.query.session;
        let appId = to.query.app_id;
        let bannerId = to.query.banner_id ? to.query.banner_id : 7;
        // 抽奖活动逻辑判断
        LotteryService.getInfo(userCode, session, appId, bannerId)
            .then(res => {
                console.log(res.data)
                if (res.data.result_code === 200) {
                    let activityStatus = res.data.info.activity_status;
                    let oneJoin = res.data.info.one_join;
                    let twoJoin = res.data.info.two_join
                    let prizeFinish = res.data.info.prize_finish
                    let winFlag = res.data.info.win_flag
                    let signUp = res.data.info.sign_up
                    let activityBatch = res.data.info.activity_batch
                    if (activityStatus === 0 || activityStatus === 1) {
                        next({name: 'Apply', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId
                            }}); // 第一阶段报名
                    }
                    else if (oneJoin === 1 && winFlag === 1) {
                        if (activityStatus === 3 || activityStatus === 4 || activityStatus === 5 || activityStatus === 6) {
                            next({name: 'WinPrize', query: {
                                    user_code: userCode,
                                    session: session,
                                    app_id: appId,
                                    banner_id: bannerId,
                                    stage: 'first'
                                }}); // 第一次已经抽取中奖
                        } else {
                            next({name: 'WinPrize', query: {
                                    user_code: userCode,
                                    session: session,
                                    app_id: appId,
                                    banner_id: bannerId,
                                    stage: 'second'
                                }}); // 第二次已经抽取中奖
                        }
                    }
                    else if (twoJoin === 1 && winFlag === 1) {
                        next({name: 'WinPrize', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second'
                            }}); // 第二次已经抽取中奖
                    }
                    else if (activityStatus === 4 || activityStatus === 5) {
                        next({name: 'SecondApply', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second'
                            }}); // 第二阶段报名
                    }
                    else if (signUp === 1 && activityStatus === 3 && activityBatch === 2) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second',
                                sortType: 'success'
                            }}); // 第一轮用户无资格没报名 弹出点击第二次立即报名按钮 显示报名成功页
                    }
                    else if (twoJoin === 1 && winFlag === 0) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second',
                                sortType: 'nowin'
                            }}); // 第二次已经抽取未中奖
                    }
                    else if ( (activityStatus === 7 && prizeFinish === 1) || activityStatus === 8) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second',
                                sortType: 'empty'
                            }}); //   第二次奖品已经发完 + 活动结束默认奖品已经发完
                    }
                    else if (signUp === 0 && (activityStatus === 6 || activityStatus === 7 || activityStatus === 8) ) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'second',
                                sortType: 'unqualified'
                            }
                        }); // 用户第二波没报名无资格抽奖直接显示没有资格页
                    }
                    else if (oneJoin === 1 && winFlag === 0 && activityStatus === 3 ) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'first',
                                sortType: 'nowin'
                            }}); // 第一次已经抽取未中奖
                    }
                    else if ( activityStatus === 3 && prizeFinish === 1 && signUp === 1) {
                        next({name: 'DisplayDetails', query: {
                                user_code: userCode,
                                session: session,
                                app_id: appId,
                                banner_id: bannerId,
                                stage: 'first',
                                sortType: 'empty'
                            }}); //   第一次奖品已经发完且已经报名的
                    }
                    else {
                        next()
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
    } else {
        next();
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
